function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 19.32C0 12.4861 0 9.06917 1.35104 6.46831C2.48955 4.27659 4.27659 2.48955 6.46831 1.35104C9.06917 0 12.4861 0 19.32 0H26.68C33.5139 0 36.9308 0 39.5317 1.35104C41.7234 2.48955 43.5105 4.27659 44.649 6.46831C46 9.06917 46 12.4861 46 19.32V26.68C46 33.5139 46 36.9308 44.649 39.5317C43.5105 41.7234 41.7234 43.5105 39.5317 44.649C36.9308 46 33.5139 46 26.68 46H19.32C12.4861 46 9.06917 46 6.46831 44.649C4.27659 43.5105 2.48955 41.7234 1.35104 39.5317C0 36.9308 0 33.5139 0 26.68V19.32Z",
  fill: "#4267B2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.9529 46V28.8562H34.5232L35.3577 22.1459H28.9529V17.8721C28.9529 15.9337 29.4715 14.613 32.1504 14.613H35.5455V8.62746C34.9548 8.54595 32.9282 8.36365 30.57 8.36365C25.6464 8.36365 22.2768 11.4807 22.2768 17.2075V22.1459H16.7273V28.8562H22.2768V46H28.9529Z",
  fill: "white"
});

var SvgFacebookNew = function SvgFacebookNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook_new.369a1d27.svg";
export { ForwardRef as ReactComponent };